// extracted by mini-css-extract-plugin
module.exports = {"form_holder_div":"Login_form_holder_div__3TDyf","cancel_form_button":"Login_cancel_form_button__2GOHb","error_message":"Login_error_message__2DPNt"};